import { Badge } from "@/components/ui/Badge";
import {
  Card,
  CardHeader,
  CardContent,
  CardTitle,
  CardDescription,
} from "@/components/shadcn/card";
import { AppointmentActionDropdown } from "../appointment/actions";

export default function AppointmentRow(props) {
  const row = props.item;

  const onHandle = () => {};

  return (
    <div
      items={props.items}
      key={row.key}
      action={false}
      move={false}
      onToggle={(key) => props.onCheck(key)}
      onHandle={onHandle}
    >
      <Card>
        <CardHeader class="pb-2 flex justify-between flex-row items-center">
          <div>
            <CardTitle>{row.patient}</CardTitle>
            <CardDescription class="text-sm">{row.doctor}</CardDescription>
          </div>
          <div class="flex gap-2 items-center">
            <AppointmentActionDropdown onAction={props.onAction} key={row.key} status={row.status} />
          </div>
        </CardHeader>
        <CardContent>
          <p>Slot: {row.slot}</p>
          <p>Room: {row.room}</p>
          <p>
            Status:{" "}
            <Badge variant={row.status ? "success" : "warning"}>
              {row.status}
            </Badge>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
